export const getModalFooterSize = (isMobile: boolean) => (isMobile ? 120 : 83);

export const getModalContentXPadding = (isSmallWidth: boolean) => (isSmallWidth ? 2 : 4);
export const getModalContentYPadding = (isSmallWidth: boolean) => (isSmallWidth ? 10 / 4 : 3);
